import { auth } from './fixture'

export default {
  auth: { ...auth },
  error: null, // The last error manually encountered
  errorCode: null, // Check current state of error code
  application: null, // Complete dataset for the currently displayed application
  counties: null, // Externally controlled source of data for <select> options (among other fields)
  currentApplication: null, // capture the vital information on the welcome page to be used in the pending application process
  sections: [], // Array of application form sections (defined in applicationDefinition > applicationSections.js)
  refData: null, // Externally controlled source of data for <select> options (among other fields)
  alerts: [], // Array of alerts for the currently displayed application
  counters: [], // Array of counters used for completion status
  messageBox: {}, // If a message box is to be displayed, its configuration must be inserted into this object
  modal: {}, // Determines which modal dialog (if any) to display
  saveStatus: null, // Show the database save status of the application data (Saving, Saved or null)
  showSpinner: false,
  showOverlay: false,
  showMenu: false,
  isNewApplication: false, // True if choosing the new application flow, not the resume flow.
  oesProperties: {}, // Externally controlled data to allow for updates to the portal without a full deploy. Currently only holds values for footer links endpoints.
  focusID: null, //Used to set focus to an focusable element with the ID
  inTrainingMode: false, //Whether or not we are in training mode  
  notificationQueue: [], //A queue to place notification objects. The queue will be consumed by NotificationQueue.
  uploadStatuses: {}, //Current status of a file upload component. Used to block navigation while removing/uploading a file.
  resumeViaEmail: false, // set to true when user resume via email (need to skip pending offer page when user resume via email)
  resumeViaButton: false, //set to true when user resume via button in landing page
  ooaApplicationID: null, // set to proceed OOA application,
  hasPendingApplication: false, // set to redirect when no pending offers found
  declinedExistingApplication: [], // list of declined ooa offers
  submittedApplicationId: null
}
